import { useEffect, useRef, useState } from "react";
import ProgressBar from "./ProgressBar";
import Controller from "./Controller";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 100px;
`;

const AnimationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
`;

const ImageContainer = styled.div`
  position: relative;
  display: inline-block;
  left: -18px;

  img {
    display: block;
    width: 600px; /* 이미지 크기 조정 */
    clip-path: circle(200px at 53% 50%); /* 원형 클리핑 */
  }
`;

interface SkycamAnimationProps {
  images: string[];
}

export default function SkycamAnimation({images}: SkycamAnimationProps) {
  const [values, setValues] = useState({
    fps: 24,
    contrast: 100,
    brightness: 100
  });
  const [index, setIndex] = useState(0);
  const intervalRef = useRef<any>(null);
  const {fps, contrast, brightness} = values;

  const onValuesChange = (newValues: {fps: number, contrast: number, brightness: number}) => {
    setValues(newValues);
  }

  useEffect(() => {
    const updateFrame = () => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(updateFrame, 1000 / fps);

    return () => clearInterval(intervalRef.current);
  }, [images, fps]);

  return <Wrapper>
    <AnimationWrapper>
      <ImageContainer>
        <img src={images[index]} style={{filter: `contrast(${contrast}%) brightness(${brightness}%)`}} />
      </ImageContainer>
      <ProgressBar index={index} total={images.length} />
    </AnimationWrapper>
    <div>
      <Controller values={values} onValuesChange={onValuesChange} />
    </div>
  </Wrapper>
}